import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DoctorList_Main.html?raw';
import on from 'dojo/on';
import dojoDate from 'dojo/date/locale';
import MainPropertiesV2 from '../../WebCalendar_TS/MainProperties/MainPropertiesV2';
import BookingDetails from '../DoctorList/BookingDetails/BookingDetails';
import "../DoctorList/BookingDetails/BookingDetails";
import "../../WebCalendar_TS/MainProperties/MainProperties";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import AdminCenter from '../DoctorList/AdminCenter/AdminCenter';
import RegistrationForm from '../DoctorList/RegistrationForm/RegistrationForm';
import { ExtraHelpers, ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class DoctorList_Main extends compose(_WidgetBaseSP) {

    templateString: any = template;

    mainProperties: MdsLax<InstanceType<typeof MainPropertiesV2>>;

    private docPaneContent: HTMLDivElement;
    private docPaneAdminContent: HTMLDivElement;

    private btnAdminCenter: HTMLButtonElement;
    private _registerForm: MdsLax<InstanceType<typeof RegistrationForm>>;

    private _calendarCreated() {


        //this.mainProperties.setShowEndTime(true);

        //this.mainProperties.calendar.setAutoAdjust(false);

        if (!this._checkUrlParameters("item")) {
            this._checkUrlParameters("nav");
        }
    }


    private _checkUrlParameters(targetAction?: string): boolean {
        let action: any = this.getUrlParameterValue(DoctorList_UrlParameters.action);
        //this.removeUrlParameter("adminCenter");

        if (targetAction) {
            if (action != targetAction) {
                return;
            }
        }

        //console.log("url parameters action", action);

        if (action != false) {

            if (action != "adminCenter") {
                this.removeUrlParameter(DoctorList_UrlParameters.adminCenterTarget);
            }

            if (action == "adminCenter") {
                let value = this.getUrlParameterValue(DoctorList_UrlParameters.adminCenterTarget);
                this.hasUserRole("DOC-ADMIN", lang.hitch(this, this._tryOpenAdminDlg));
            }

            else if (action == "item" && this.mainProperties) {
                if (this.mainProperties.syncFusionCalendar) {

                    let value = this.getUrlParameterValue(DoctorList_UrlParameters.item);
                    //console.debug("action: ", action, value);
                    if (value != false) {
                        let txtStart = this.getUrlParameterValue(DoctorList_UrlParameters.dateStart);
                        let txtEnd = this.getUrlParameterValue(DoctorList_UrlParameters.dateEnd);
                        let viewtype = this.getUrlParameterValue(DoctorList_UrlParameters.intervalType);


                        let dateStart = dojoDate.parse(txtStart, { datePattern: "yyyy-MM-dd", selector: "date" })
                        let dateEnd = dojoDate.parse(txtEnd, { datePattern: "yyyy-MM-dd", selector: "date" })

                        this.mainProperties.syncFusionCalendar.setScheduleSelectedDate(dateStart);
                        //this.mainProperties.calendar.setItemToHighlight(value); // geht ned. kann mit den items nix machen.
                        let entries = this.mainProperties.syncFusionCalendar.getItemNodes();
                        for (let entry of entries) {
                            if (entry.event.Id == value) {
                                this.UiModder.domClass.add(entry.node, "highlight");
                                break;
                            }
                        }

                        return true;
                    }
                } else {
                    //console.warn("cannot use url action for item - no calendar");
                }
            }

            else if (action == "editMe") {
                this.showOwnDoctorInfo();
                return true;
            }

            return false;
        }

    }

    showBookingDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        //console.debug("showBookingDetails", item);
        //this.mainProperties.calendar.get
        //let calendar = this.mainProperties.calendar;
        //let interval = calendar.get("dateInterval");
        //let steps = calendar.get("dateIntervalSteps");
        let startDate = new Date(item.startTime);
        //let endDate = calendar._timeInterval[1];

        //startDate = item.startTime;

        let bookingDetails = new BookingDetails();
        bookingDetails.itemId = item.id;
        bookingDetails.DoclistMainWrapper = this;

        //this.setUrlParameter(DoctorList_UrlParameters.item, item.id);

        bookingDetails.startup();

        let dlg = new GenericDialog();
        dlg.setCloseOnEscape(true);
        dlg._setCloseBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);

        dlg._setCallbackAttr(lang.hitch(this, function () {
            this.removeUrlParameter(DoctorList_UrlParameters.action);
            this.removeUrlParameter(DoctorList_UrlParameters.item);
            this.removeUrlParameter(DoctorList_UrlParameters.dateEnd);
            this.removeUrlParameter(DoctorList_UrlParameters.dateStart);
            this.removeUrlParameter(DoctorList_UrlParameters.intervalType);
        }))

        dlg._setHeaderAttr(item.columnview_head_text);

        dlg.addNodeToContent(bookingDetails.domNode);
        dlg.show();
    }

    //_setupSubscriptions(): void {

    //    let self: any = this;
    //    self.inherited(arguments);

    //    // sonst warten wir darauf
    //    this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onOpenSession));
    //}

    //private _onOpenSession(data: any) {
    //    this._session = data;
    //    //this._continueWithSession();

    //}

    private _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainPropertiesV2();

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));

        this.UiModder.domStyle.set(this.mainProperties.domNode, "height", "100%");
        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showBookingDetails);

        this.mainProperties.setMainConfig({
            enableLocalUserSettings: false,
            dataLoadingLabel: this.translate("Doctorlist__Label_LoadingData", true),
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl:
            },
            userProperties: {
                customFunctionName: "Webtool_API_DoctorList__GetWebCalendarUserProperties",
                //requestUrl: "Doctorlist/GetUserProperties"
                requestParams: [{ name: "jsonData", value: { user: "unknown" } }]
            },
            filterData: {
                //requestUrl: "Doctorlist/GetFilterData"
                customFunctionName: "Webtool_API_DoctorList__GetFilterData"
            },
            defaultDisplaySettings: {
                b_show_end_time: true,
                autoAdjustToDisplay: false
                //hideColumnHead: true
            },
            enableQuickSearch: false,
            checkCreateAppointmentPrivileges: false
        });
        //this.mainProperties.bShowEndTime = true;

        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        this.mainProperties.setTitles(
            this.stringFormat(this.translate("Doctorlist__MainTitle"), this.translate("MainTitle")),
            this.translate("Doctorlist__Title"));

        this._checkUrlParameters("item");
    }

    private _OnClick_Admin(evt: MouseEvent) {

        evt.stopPropagation();

        if (!this.hasUserRole("DOC-ADMIN")) {
            return;
        }

        this._openAdminDlg();
    }
    private _tryOpenAdminDlg(hasPriv: boolean) {
        //console.debug("doctorlist tryopen admincenter", hasPriv);
        if (hasPriv === true) {
            this._openAdminDlg();
        }
    }

    private async _openAdminDlg(): Promise<void> {
        await ExtraHelpers.sideLoadResource(window.appRoot + "Content/tabulator/js/tabulator.min.js", 'js' );
        var form = new AdminCenter();

        //this.setUrlParameter(DoctorList_UrlParameters.action, "adminCenter");

        var dlg = new GenericDialog();
        //this.UiModder.domClass.replace(dlg.headerBarNode, "accentBG", "secondaryBG");
        dlg.set("header", this.translate("Doctorlist__WebcalendarPanel_Admin_Btn"));
        dlg.set("callback", lang.hitch(this, function (form) {
            this.removeUrlParameter(DoctorList_UrlParameters.action);
            this.removeUrlParameter(DoctorList_UrlParameters.adminCenterTarget);
            form.stopRequest();
        }, form));
        dlg.addNodeToContent(form.domNode);
        dlg._setCloseBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg.propagateClick = false;

        form.startup();

        dlg.show();
    }

    private _OnClick_EditUser(evt: MouseEvent): void {
        evt.stopPropagation();

        this.showOwnDoctorInfo();
    }

    private showOwnDoctorInfo(): void {

        //console.log(this);
        this.StandbyStart();

        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.propagateClick = false;
        dlg.keepOpen = true;

        dlg.show(this.translate("General_Loading"),
            this.translate("Doctorlist__WebcalendarPanel_Edit_Btn"),
            null,
            null,
            "saveclose",
            lang.hitch(this, this._onEditUserDlgResponse, dlg));

        dlg.disableButton("save");

        this.setUrlParameter(DoctorList_UrlParameters.action, "editMe");

        this.RequestManager.callfunction(
            "Webtool_API_DoctorList__GetCurrentDoctorInfo",
            {},
            lang.hitch(this, this._onGetOwnDoctorInfoResponse, dlg),
            lang.hitch(this, this._onGetOwnDoctorInfoError, dlg)
        );
    }
    private _onRegisterFormDirty(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof RegistrationForm>>, state: boolean) {

        //console.debug("AdminCenter _addSaveButtonToEditDlg", state, typeof (dlg), typeof (form));

        dlg.enableButton("save", state)
    }

    private _onGetOwnDoctorInfoResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response: any): void {
        console.info(response);
        this.StandbyStop();

        let form = new RegistrationForm();
        this._registerForm = form;
        form.startup();

        //form.finished = resetHitched;

        dlg._setContentAttr("");
        dlg.addNodeToContent(form.domNode);

        form.parentDialog = dlg;
        form.setData(response, false, "showMarker");

        on(form, "dirty", lang.hitch(this, this._onRegisterFormDirty, dlg, form));

    }

    private _onEditUserDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response: number) {
        this.removeUrlParameter(DoctorList_UrlParameters.action);

        if (response >= 1 && this._registerForm) {
            this._registerForm.saveEdit();
        } else {
            dlg.close(-1, true);
        }
    }

    _onGetOwnDoctorInfoError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: any): void {
        this.StandbyStop();

        dlg._setContentAttr(error.Message);

        if (this.mainProperties) {
            //this.mainProperties.publishToastMessage()
        }

        console.error(error);
    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

        this.hasUserRole("DOC-ADMIN", lang.hitch(this, this._prepareDocAdminPanel));


        props.addCustomPane("doctorlist", this.translate("DoctorList__WebcalendarPanel_Doc"), this.docPaneContent, "fas fa-stethoscope");

        props.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.searchPane);
        props.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane);
        props.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.userPane); // umschalten des Kalenders in Arztliste nicht gewollt!

        props.expandPane("doctorlist");
        props.expandPane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);

    }

    private _prepareDocAdminPanel(result: boolean): void {
        if (this.hasUserRole("DOC-ADMIN")) {
            //this.mainProperties.addCustomPane("doctorlistAdmin",
            //    this.translate("DoctorList__WebcalendarPanel_DocAdmin"],
            //    this.docPaneAdminContent,
            //    "fas fa-stethoscope");
            //this.UiModder.domClass.remove(this.docPaneAdminContent, "w3-hide");
            this._checkUrlParameters("adminCenter"); // prüfen ob admincenter als Action drinsteht, dann öffnen

            this.UiModder.domClass.remove(this.btnAdminCenter, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.docPaneAdminContent, "w3-hide");

            this.UiModder.domClass.add(this.btnAdminCenter, "w3-hide");
        }
    }

    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();
    }

}

export default mdsWidget(DoctorList_Main);
